import axios from 'axios'
import Endpoints from '../Endpoints'

export const listQuizzes = async () => {
  const { data } = await axios.get(Endpoints.Quiz.LIST_ADMIN, { headers: { Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}` }})
  return data?.data ?? []
}

export const getQuiz = async (id) => {
  const { data } = await axios.get(Endpoints.Quiz.GET_ADMIN + id, { headers: { Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}` }})
  return data?.data ?? data
}

export const createQuiz = async (payload) => {
  const { data } = await axios.post(Endpoints.Quiz.CREATE, payload, { headers: { Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}` }})
  return data?.data ?? data
}

export const updateQuiz = async (id, payload) => {
  const { data } = await axios.put(Endpoints.Quiz.UPDATE + id, payload, { headers: { Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}` }})
  return data?.data ?? data
}

export const deleteQuiz = async (id) => {
  const { data } = await axios.delete(Endpoints.Quiz.DELETE + id, { headers: { Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}` }})
  return data?.data ?? data
}

export const submitQuiz = async (id, payload) => {
  const { data } = await axios.post(Endpoints.Quiz.SINGLE + id + '/submit', payload, { headers: { Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}` }})
  return data?.data ?? data
}

export const getQuizStats = async (id) => {
  const { data } = await axios.get(Endpoints.Quiz.SINGLE + id + '/stats', { headers: { Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}` }})
  return data?.data ?? data
}
